import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Link, Outlet, retainSearchParams } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import { t } from '@/lib/i18n';
import { type GlobalSearch, validateGlobalSearch } from '@/lib/search';
import { Button, EmptyState, Toaster } from '@/ui';
import s from './App.module.css';

export interface RouterContext {
  queryClient: QueryClient;
}

function Root() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}

export function NotFound() {
  return (
    <div className={s.notFound}>
      <EmptyState
        icon={Compass}
        title={t('This page does not exist')}
        description={t('The link may be old, or the page moved. Everything has one address in Nova; search finds it.')}
        action={
          <Link to="/">
            <Button variant="primary">{t('Go to Home')}</Button>
          </Link>
        }
      />
    </div>
  );
}

/** Global search params (project scope, time range) live on the root and survive navigation. */
export const rootRoute = createRootRouteWithContext<RouterContext>()({
  validateSearch: (search: Record<string, unknown>): GlobalSearch => validateGlobalSearch(search),
  search: { middlewares: [retainSearchParams<GlobalSearch>(['p', 'range', 'from', 'to'])] },
  component: Root,
  notFoundComponent: NotFound,
});
